import { render, staticRenderFns } from "./VizibillMonerisForm.vue?vue&type=template&id=491a4c10&scoped=true&"
import script from "./VizibillMonerisForm.vue?vue&type=script&lang=js&"
export * from "./VizibillMonerisForm.vue?vue&type=script&lang=js&"
import style0 from "./VizibillMonerisForm.vue?vue&type=style&index=0&id=491a4c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a4c10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer,VFlex,VLayout,VSpacer})
